import React from "react";
import "./AccionesFiltroPanel.css";
import ViewportSelect from "./ViewportSelect";

/**
 * @typedef {{
 *   nombre: string,
 *   accionTipo: string,
 *   fechaDesde: string,
 *   fechaHasta: string,
 *   rol: string,
 * }} AccionesFiltrosValue
 */

/**
 * @param {{
 *   draftFiltros: AccionesFiltrosValue,
 *   onDraftChange: (next: AccionesFiltrosValue) => void,
 *   onApply: () => void,
 *   onClear: () => void,
 *   tipoOptions: { value: string, label: string }[],
 *   rolOptions: { value: string, label: string }[],
 *   labels: {
 *     nombre: string,
 *     tipo: string,
 *     rol: string,
 *     desde: string,
 *     hasta: string,
 *     apply: string,
 *     clear: string,
 *   },
 * }} props
 */
export default function AccionesFiltroPanel({
  draftFiltros,
  onDraftChange,
  onApply,
  onClear,
  tipoOptions,
  rolOptions,
  labels,
}) {
  const patch = (/** @type {Record<string, string>} */ partial) => {
    onDraftChange({ ...draftFiltros, ...partial });
  };

  const handleSubmit = (/** @type {React.FormEvent<HTMLFormElement>} */ e) => {
    e.preventDefault();
    onApply();
  };

  return (
    <form
      className="acciones-filtro-panel"
      role="search"
      aria-label={labels.tipo}
      onSubmit={handleSubmit}
    >
      <div className="acciones-filtro-panel__row">
        <label className="acciones-filtro-panel__label">
          <span>{labels.nombre}</span>
          <input
            type="text"
            value={draftFiltros.nombre}
            onChange={(e) => patch({ nombre: e.target.value })}
            autoComplete="off"
            aria-label={labels.nombre}
          />
        </label>
        <label className="acciones-filtro-panel__label">
          <span>{labels.tipo}</span>
          <ViewportSelect
            value={draftFiltros.accionTipo}
            onChange={(e) => patch({ accionTipo: e.target.value })}
            aria-label={labels.tipo}
            className="acciones-filtro-panel__select"
          >
            {tipoOptions.map((o) => (
              <option key={o.value === "" ? "__all_tipos__" : o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </ViewportSelect>
        </label>
        <label className="acciones-filtro-panel__label">
          <span>{labels.rol}</span>
          <ViewportSelect
            value={draftFiltros.rol}
            onChange={(e) => patch({ rol: e.target.value })}
            aria-label={labels.rol}
            className="acciones-filtro-panel__select"
          >
            {rolOptions.map((o) => (
              <option key={o.value === "" ? "__all_roles__" : o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </ViewportSelect>
        </label>
      </div>
      <div className="acciones-filtro-panel__row">
        <label className="acciones-filtro-panel__label">
          <span>{labels.desde}</span>
          <input
            type="date"
            value={draftFiltros.fechaDesde}
            onChange={(e) => patch({ fechaDesde: e.target.value })}
            aria-label={labels.desde}
          />
        </label>
        <label className="acciones-filtro-panel__label">
          <span>{labels.hasta}</span>
          <input
            type="date"
            value={draftFiltros.fechaHasta}
            onChange={(e) => patch({ fechaHasta: e.target.value })}
            aria-label={labels.hasta}
          />
        </label>
        <div className="acciones-filtro-panel__actions acciones-filtro-panel__actions--buttons">
          <button type="submit" className="acciones-filtro-panel__apply">
            {labels.apply}
          </button>
          <button type="button" className="acciones-filtro-panel__clear" onClick={onClear}>
            {labels.clear}
          </button>
        </div>
      </div>
    </form>
  );
}
